import React, { useMemo } from 'react'
import { SubwebCard } from 'components/molecules'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import { Text } from 'components/atoms'

const loadingData = [
  {
    title: '',
    name: '',
    id: 1,
  },
  {
    title: '',
    name: '',
    id: 2,
  },
]

const SubwebsCardList = ({ data, loading }) => {
  const hasData = useMemo(() => data && data.length > 0, [data])

  if (loading) {
    return (
      <SubwebsList>
        {loadingData.map(dummy => (
          <SubwebCard key={dummy.id} title={dummy.title} shortTitle={dummy.name} />
        ))}
      </SubwebsList>
    )
  }

  return (
    <SubwebsList>
      {hasData ? data.map(subweb => (
        <Link to={`/${encodeURIComponent(subweb.slug)}`} key={subweb.id}>
          <SubwebCard
            title={subweb.description}
            titleShort={subweb.slug}
            activeColor={subweb.color}
            modifiers={['stretchHeight']}
          />
        </Link>
      )) : <Text>Não tem subwebs</Text>}
    </SubwebsList>
  )
}

const SubwebsList = styled.div`
  a {
    text-decoration: none;
  }
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 160px));
  grid-template-rows: 1fr;
  grid-column-gap: ${props => props.theme.spacing.m};
  grid-row-gap:  ${props => props.theme.spacing.m};
`

SubwebsCardList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    titleShort: PropTypes.string,
    color: PropTypes.string
  })),
  loading: PropTypes.bool,
}

SubwebsCardList.defaultProps = {
  data: [],
  loading: false,
}

export default SubwebsCardList
